<template>
  <div id="LinesList">
    <SolutionsList
      :list="list"
      :view-loader="viewLoader"
      :view-error="viewError"
      :no-data-message="$t('crossConnects.noData')"
      :colspan="10"
    >
      <template #table-headers>
        <th v-show="!$IsMobile()">{{ $t("crossConnects.ticket_esteso") }}</th>
        <th>{{ $t("crossConnects.tipologia") }}</th>
        <th>{{ $t("crossConnects.a_end_rack") }}</th>
        <th>{{ $t("crossConnects.a_end_unita") }}</th>
        <th>{{ $t("crossConnects.a_end_slot") }}</th>
        <th>{{ $t("crossConnects.a_end_fibre") }}</th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
      </template>
      <template #mobile-row="{ item }">
        <MobileCard
          :titles="[
            'ticket_esteso',
            'tipologia',
            'a_end_rack',
            'a_end_unita',
            'a_end_slot',
            'a_end_fibre'
          ]"
          :item="{
            ticket_esteso: item.ticket_esteso,
            tipologia: item.tipo,
            a_end_rack: item.aend_rack_name,
            a_end_unita: item.aend_unita,
            a_end_slot: item.aend_slot,
            a_end_fibre: item.aend_fibre
          }"
          translationPath="crossConnects"
        >
          <template #url-label>
            <router-link
              :to="
                '/' +
                ($i18n.locale === 'it'
                  ? 'cross-connects-attive/dettaglio/'
                  : 'active-cross-connects/detail/') +
                (item.xcon_id || item.id)
              "
            >
              <div class="cdlButton">
                <span>
                  {{ $t("crossConnects.details") }}
                </span>
              </div>
            </router-link>
          </template>
        </MobileCard>
      </template>
      <template #desktop-row="{ item }">
        <tr>
          <td>
            <span>
              {{ item.ticket_esteso }}
            </span>
          </td>
          <td>
            <div>{{ item.tipo }}</div>
          </td>
          <td>
            <div>{{ item.aend_rack_name || "-" }}</div>
          </td>
          <td>
            <div>{{ item.aend_unita || "-" }}</div>
          </td>
          <td>
            <div>{{ item.aend_slot || "-" }}</div>
          </td>
          <td>
            <div>{{ item.aend_fibre || "-" }}</div>
          </td>

          <td></td>
          <td>
            <router-link
              :to="
                '/' +
                ($i18n.locale === 'it'
                  ? 'cross-connects-attive/dettaglio/'
                  : 'active-cross-connects/detail/') +
                (item.xcon_id || item.id)
              "
            >
              <div class="cdlButton">{{ $t("crossConnects.details") }}</div>
            </router-link>
          </td>
          <td colspan="3">
            <div style="display: flex">
              <HelpRequestBtn
                v-if="ctrlPerms(['incident_lista'])"
                :component-name="'CrossConnectIncidentForm'"
                :asset-type="'cross-connects'"
                :item-id="item.xcon_id || item.id"
                :icon="'warning'"
                :label="$t('help.incident.formTitle')"
                :skip-duplicate-warning="true"
              />

              <HelpRequestBtn
                v-if="ctrlPerms(['change_request_list'])"
                :component-name="'CrossConnectChangeRequestForm'"
                :asset-type="'cross-connects'"
                :item-id="item.xcon_id || item.id"
                :icon="'person'"
                :label="$t('help.changeRequest.formTitle')"
                :skip-duplicate-warning="true"
              />
            </div>
          </td>
        </tr>
      </template>
    </SolutionsList>
  </div>
</template>

<script>
import SolutionsList from "@/components/Solutions/SolutionsList.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import MobileCard from "@/components/Cards/MobileCard.vue";
import "@/assets/scss/Solutions.scss";

export default {
  name: "CrossConnectList",
  components: {
    SolutionsList,
    HelpRequestBtn,
    MobileCard,
  },
  props: {
    list: Array,
    viewLoader: Boolean,
    viewError: Boolean,
  },
  methods: {
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
  },
};
</script>
